/*
 * Auth module
 */
export const AUTH_LOGIN_PENDING = 'AUTH_LOGIN_PENDING';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';

export const AUTH_ACTIVATION_PENDING = 'AUTH_ACTIVATION_PENDING';
export const AUTH_ACTIVATION_SUCCESS = 'AUTH_ACTIVATION_SUCCESS';
export const AUTH_ACTIVATION_FAILURE = 'AUTH_ACTIVATION_FAILURE';

export const AUTH_RESET_PENDING = 'AUTH_RESET_PENDING';
export const AUTH_RESET_SUCCESS = 'AUTH_RESET_SUCCESS';
export const AUTH_RESET_FAILURE = 'AUTH_RESET_FAILURE';

export const AUTH_FORGOT_PENDING = 'AUTH_FORGOT_PENDING';
export const AUTH_FORGOT_SUCCESS = 'AUTH_FORGOT_SUCCESS';
export const AUTH_FORGOT_FAILURE = 'AUTH_FORGOT_FAILURE';

export const AUTH_USER_SET = 'AUTH_USER_SET';
export const AUTH_USER_UNSET = 'AUTH_USER_UNSET';
export const AUTH_SUPPLIERS_SET = 'AUTH_SUPPLIERS_SET';
export const AUTH_PRODUCT_TYPES_SET = 'AUTH_PRODUCT_TYPES_SET';

export const AUTH_MESSAGE_SET = 'AUTH_MESSAGE_SET';
export const AUTH_REFERRER_SET = 'AUTH_REFERRER_SET';
export const AUTH_REFERRER_UNSET = 'AUTH_REFERRER_UNSET';

export const AUTH_PRODUCT_TYPES_PENDING = 'AUTH_PRODUCT_TYPES_PENDING';
export const AUTH_PRODUCT_TYPES_SUCCESS = 'AUTH_PRODUCT_TYPES_SUCCESS';
export const AUTH_PRODUCT_TYPES_FAILURE = 'AUTH_PRODUCT_TYPES_FAILURE';

export const AUTH_SUPPLIERS_LIST_PENDING = 'AUTH_SUPPLIERS_LIST_PENDING';
export const AUTH_SUPPLIERS_LIST_SUCCESS = 'AUTH_SUPPLIERS_LIST_SUCCESS';
export const AUTH_SUPPLIERS_LIST_FAILURE = 'AUTH_SUPPLIERS_LIST_FAILURE';

export const AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING = 'AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING';
export const AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS = 'AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS';
export const AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE = 'AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE';

export const AUTH_SUPPLIER_SET = 'AUTH_SUPPLIER_SET';
export const AUTH_SUPPLIER_UNSET = 'AUTH_SUPPLIER_UNSET';
export const AUTH_PRODUCT_TYPE_SET = 'AUTH_PRODUCT_TYPE_SET';

/*
 * Nav module
 */
export const NAV_MINIMIZE_TOGGLE = 'NAV_MINIMIZE_TOGGLE';
export const NAV_MINIMIZE_SET = 'NAV_MINIMIZE_SET';
export const NAV_MENU_TOGGLE = 'NAV_MENU_TOGGLE';

/*
 * Booking module
 */
export const BOOKING_RESET_STATE = 'BOOKING_RESET_STATE';

export const BOOKING_FETCH_PENDING = 'BOOKING_FETCH_PENDING';
export const BOOKING_FETCH_SUCCESS = 'BOOKING_FETCH_SUCCESS';
export const BOOKING_FETCH_FAILURE = 'BOOKING_FETCH_FAILURE';
export const BOOKING_FETCH_NO_CONTENT = 'BOOKING_FETCH_NO_CONTENT';

export const BOOKING_PAGE_INCREMENT = 'BOOKING_PAGE_INCREMENT';
export const BOOKING_PAGE_DECREMENT = 'BOOKING_PAGE_DECREMENT';
export const BOOKING_PAGE_SET = 'BOOKING_PAGE_SET';

export const BOOKING_PREDICATE_SET = 'BOOKING_PREDICATE_SET';
export const BOOKING_MULTI_PREDICATE_SET = 'BOOKING_MULTI_PREDICATE_SET';
export const BOOKING_MULTI_PREDICATE_UNSET = 'BOOKING_MULTI_PREDICATE_UNSET';
export const BOOKING_MULTI_PREDICATE_RESET = 'BOOKING_MULTI_PREDICATE_RESET';
export const BOOKING_MULTI_PREDICATE_SELECT = 'BOOKING_MULTI_PREDICATE_SELECT';
export const BOOKING_LIMIT_SET = 'BOOKING_LIMIT_SET';
export const BOOKING_ORDER_SET = 'BOOKING_ORDER_SET';

export const BOOKING_FILTER_PENDING = 'BOOKING_FILTER_PENDING';
export const BOOKING_FILTER_FAILURE = 'BOOKING_FILTER_FAILURE';
export const BOOKING_FILTER_SUCCESS = 'BOOKING_FILTER_SUCCESS';
export const BOOKING_FILTER_SEARCH = 'BOOKING_FILTER_SEARCH';

export const BOOKING_SET_SELECTED_FILTERS = 'BOOKING_SET_SELECTED_FILTERS';
export const BOOKING_SET_BOOKING_PERIOD = 'BOOKING_SET_BOOKING_PERIOD';
export const BOOKING_SET_ARRIVAL_PERIOD = 'BOOKING_SET_ARRIVAL_PERIOD';

/*
 * Stat module
 */
export const STAT_RESET_STATE = 'STAT_RESET_STATE';

export const STAT_REVENUE_TOTAL_PENDING = 'STAT_REVENUE_TOTAL_PENDING';
export const STAT_REVENUE_TOTAL_SUCCESS = 'STAT_REVENUE_TOTAL_SUCCESS';
export const STAT_REVENUE_TOTAL_FAILURE = 'STAT_REVENUE_TOTAL_FAILURE';
export const STAT_REVENUE_TOTAL_NO_CONTENT = 'STAT_REVENUE_TOTAL_NO_CONTENT';

export const STAT_REVENUE_PERIOD_PENDING = 'STAT_REVENUE_PERIOD_PENDING';
export const STAT_REVENUE_PERIOD_SUCCESS = 'STAT_REVENUE_PERIOD_SUCCESS';
export const STAT_REVENUE_PERIOD_FAILURE = 'STAT_REVENUE_PERIOD_FAILURE';
export const STAT_REVENUE_PERIOD_NO_CONTENT = 'STAT_REVENUE_PERIOD_NO_CONTENT';

export const STAT_UPDATE_BOOKING_PERIOD = 'STAT_UPDATE_BOOKING_PERIOD';
export const STAT_UPDATE_ARRIVAL_PERIOD = 'STAT_UPDATE_ARRIVAL_PERIOD';
export const STAT_UPDATE_SELECTED_SITE = 'STAT_UPDATE_SELECTED_SITE';

export const STAT_UPDATE_SELECTED_STAT_LIST_ITEM = 'STAT_UPDATE_SELECTED_STAT_LIST_ITEM';

export const STAT_UPDATE_DROPDOWN_SITES = "STAT_UPDATE_DROPDOWN_SITES";
export const STAT_UPDATE_DROPDOWN_ACCOMMODATION = "STAT_UPDATE_DROPDOWN_ACCOMMODATION";
export const STAT_UPDATE_DROPDOWN_LIST = "STAT_UPDATE_DROPDOWN_LIST";

/*
 * Allocation module
 */
export const ALLOCATION_RESET_STATE = 'ALLOCATION_RESET_STATE';

export const ALLOCATION_DATA_FETCH_PENDING = 'ALLOCATION_DATA_FETCH_PENDING';
export const ALLOCATION_DATA_FETCH_SUCCESS = 'ALLOCATION_DATA_FETCH_SUCCESS';
export const ALLOCATION_DATA_FETCH_FAILURE = 'ALLOCATION_DATA_FETCH_FAILURE';

export const ALLOCATION_LIST_FETCH_PENDING = 'ALLOCATION_LIST_FETCH_PENDING';
export const ALLOCATION_LIST_FETCH_SUCCESS = 'ALLOCATION_LIST_FETCH_SUCCESS';
export const ALLOCATION_LIST_FETCH_FAILURE = 'ALLOCATION_LIST_FETCH_FAILURE';
export const ALLOCATION_LIST_FETCH_NO_CONTENT = 'ALLOCATION_LIST_FETCH_NO_CONTENT';

export const ALLOCATION_LIST_FILTERS_PENDING = 'ALLOCATION_LIST_FILTERS_PENDING';
export const ALLOCATION_LIST_FILTERS_SUCCESS = 'ALLOCATION_LIST_FILTERS_SUCCESS';
export const ALLOCATION_LIST_FILTERS_FAILURE = 'ALLOCATION_LIST_FILTERS_FAILURE';

export const ALLOCATION_LIST_PAGE_SET = 'ALLOCATION_LIST_PAGE_SET';
export const ALLOCATION_LIST_PAGE_INCREMENT = 'ALLOCATION_LIST_PAGE_INCREMENT';
export const ALLOCATION_LIST_PAGE_DECREMENT = 'ALLOCATION_LIST_PAGE_DECREMENT';

export const ALLOCATION_LIST_SELECTED_SET = 'ALLOCATION_LIST_SELECTED_SET';
export const ALLOCATION_LIST_SELECTED_RESET = 'ALLOCATION_LIST_SELECTED_RESET';
export const ALLOCATION_LIST_PREDICATE_SET = 'ALLOCATION_LIST_PREDICATE_SET';
export const ALLOCATION_LIST_LIMIT_SET = 'ALLOCATION_LIST_LIMIT_SET';
export const ALLOCATION_LIST_ORDER_SET = 'ALLOCATION_LIST_ORDER_SET';

export const ALLOCATION_LIST_DISPLAY_SELECT = 'ALLOCATION_LIST_DISPLAY_SELECT';
export const ALLOCATION_LIST_DISPLAY_RESET = 'ALLOCATION_LIST_DISPLAY_RESET';

export const ALLOCATION_FORM_ROW_ADD = 'ALLOCATION_FORM_ROW_ADD';
export const ALLOCATION_FORM_ROW_REMOVE = 'ALLOCATION_FORM_ROW_REMOVE';
export const ALLOCATION_FORM_ROW_CLEAR = 'ALLOCATION_FORM_ROW_CLEAR';
export const ALLOCATION_FORM_ROW_SET = 'ALLOCATION_FORM_ROW_SET';
export const ALLOCATION_FORM_ROW_DUPLICATE = 'ALLOCATION_FORM_ROW_DUPLICATE';
export const ALLOCATION_FORM_ROW_RESET = 'ALLOCATION_FORM_ROW_RESET';

export const ALLOCATION_FORM_SUBMIT = 'ALLOCATION_FORM_ROW_SUBMIT';
export const ALLOCATION_FORM_ACCEPT = 'ALLOCATION_FORM_ROW_ACCEPT';
export const ALLOCATION_FORM_CANCEL = 'ALLOCATION_FORM_ROW_CANCEL';
export const ALLOCATION_FORM_TOGGLE = 'ALLOCATION_FORM_TOGGLE';

export const ALLOCATION_ROUTE_FILTERS_PENDING = 'ALLOCATION_ROUTE_FILTERS_PENDING';
export const ALLOCATION_ROUTE_FILTERS_SUCCESS = 'ALLOCATION_ROUTE_FILTERS_SUCCESS';
export const ALLOCATION_ROUTE_FILTERS_FAILURE = 'ALLOCATION_ROUTE_FILTERS_FAILURE';
export const ALLOCATION_ROUTE_FILTERS_SELECTED_SET = 'ALLOCATION_ROUTE_FILTERS_SELECTED_SET';

export const ALLOCATION_SELECT = 'ALLOCATION_SELECT';

export const ALLOCATION_ALLOCATIONS_ADD_PENDING = 'ALLOCATION_ALLOCATIONS_ADD_PENDING';
export const ALLOCATION_ALLOCATIONS_ADD_SUCCESS = 'ALLOCATION_ALLOCATIONS_ADD_SUCCESS';
export const ALLOCATION_ALLOCATIONS_ADD_FAILURE = 'ALLOCATION_ALLOCATIONS_ADD_FAILURE';

export const ALLOCATION_ALLOCATIONS_FETCH_PENDING = 'ALLOCATION_ALLOCATIONS_FETCH_PENDING';
export const ALLOCATION_ALLOCATIONS_FETCH_SUCCESS = 'ALLOCATION_ALLOCATIONS_FETCH_SUCCESS';
export const ALLOCATION_ALLOCATIONS_FETCH_FAILURE = 'ALLOCATION_ALLOCATIONS_FETCH_FAILURE';
export const ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT = 'ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT';

export const ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING';
export const ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS';
export const ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE';
export const ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT';

export const ALLOCATION_ALLOCATIONS_PAGE_DECREMENT = 'ALLOCATION_ALLOCATIONS_PAGE_DECREMENT';
export const ALLOCATION_ALLOCATIONS_PAGE_INCREMENT = 'ALLOCATION_ALLOCATIONS_PAGE_INCREMENT';
export const ALLOCATION_ALLOCATIONS_PAGE_SET = 'ALLOCATION_ALLOCATIONS_PAGE_SET';
export const ALLOCATION_ALLOCATIONS_LIMIT_SET = 'ALLOCATION_ALLOCATIONS_LIMIT_SET';

export const ALLOCATION_CALENDAR_FETCH_PENDING = 'ALLOCATION_CALENDAR_FETCH_PENDING';
export const ALLOCATION_CALENDAR_FETCH_SUCCESS = 'ALLOCATION_CALENDAR_FETCH_SUCCESS';
export const ALLOCATION_CALENDAR_FETCH_FAILURE = 'ALLOCATION_CALENDAR_FETCH_FAILURE';
export const ALLOCATION_CALENDAR_DATE_SET = 'ALLOCATION_CALENDAR_DATE_SET';
export const ALLOCATION_CALENDAR_PAGE_INCREMENT = 'ALLOCATION_CALENDAR_PAGE_INCREMENT';
export const ALLOCATION_CALENDAR_PAGE_DECREMENT = 'ALLOCATION_CALENDAR_PAGE_DECREMENT';
export const ALLOCATION_CALENDAR_DISPLAY_SET = 'ALLOCATION_CALENDAR_DISPLAY_SET';
export const ALLOCATION_CALENDAR_INFO_TOGGLE = 'ALLOCATION_CALENDAR_INFO_TOGGLE';
export const ALLOCATION_CALENDAR_INFO_PAGE_SET = 'ALLOCATION_CALENDAR_INFO_PAGE_SET';

export const ALLOCATION_YEAR_SET = 'ALLOCATION_YEAR_SET';

export const ALLOCATION_MODAL_FORM_SET = 'ALLOCATION_MODAL_FORM_SET';
export const ALLOCATION_MODAL_FORM_RESET = 'ALLOCATION_MODAL_FORM_RESET';
export const ALLOCATION_FORM_VALIDATOR_FAILURE = 'ALLOCATION_FORM_VALIDATOR_FAILURE';
export const ALLOCATION_FORM_VALIDATOR_SUCCESS = 'ALLOCATION_FORM_VALIDATOR_SUCCESS';
export const ALLOCATION_FORM_VALIDATOR_RESET = 'ALLOCATION_FORM_VALIDATOR_RESET';

export const ALLOCATION_MODAL_TOGGLE = 'ALLOCATION_MODAL_TOGGLE';
export const ALLOCATION_MODAL_ADD_TOGGLE = 'ALLOCATION_MODAL_ADD_TOGGLE';
export const ALLOCATION_MODAL_PAGE_INCREMENT = 'ALLOCATION_MODAL_PAGE_INCREMENT';
export const ALLOCATION_MODAL_PAGE_DECREMENT = 'ALLOCATION_MODAL_PAGE_DECREMENT';
export const ALLOCATION_MODAL_PAGE_SET = 'ALLOCATION_MODAL_PAGE_SET';
export const ALLOCATION_MODAL_ALLOCATION_SET = 'ALLOCATION_MODAL_ALLOCATION_SET';


export const ALLOCATION_MODAL_OVERLAY_TOGGLE = 'ALLOCATION_MODAL_OVERLAY_TOGGLE';
export const ALLOCATION_MODAL_OVERLAY_FORM_SET = 'ALLOCATION_MODAL_OVERLAY_FORM_SET';
export const ALLOCATION_MODAL_OVERLAY_FORM_RESET = 'ALLOCATION_MODAL_OVERLAY_FORM_RESET';

export const ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE = 'ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE';
export const ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS = 'ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS';
export const ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING = 'ALLOCATION_ALLOCATIONS_UPDATE_PENDING';
export const ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS = 'ALLOCATION_ALLOCATIONS_UPDATE_SUCCESS';
export const ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE = 'ALLOCATION_ALLOCATIONS_UPDATE_FAILURE';
export const ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT = 'ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT';
export const ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT = 'ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT';
export const ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET = 'ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET';
export const ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET = 'ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET';

export const ALLOCATION_REQUEST_UPDATE_PENDING = 'ALLOCATION_REQUEST_UPDATE_PENDING';
export const ALLOCATION_REQUEST_UPDATE_SUCCESS = 'ALLOCATION_REQUEST_UPDATE_SUCCESS';
export const ALLOCATION_REQUEST_UPDATE_FAILURE = 'ALLOCATION_REQUEST_UPDATE_FAILURE';

export const ALLOCATION_REQUEST_CHANGE = 'ALLOCATION_REQUEST_CHANGE';
export const ALLOCATION_REQUEST_LIST_PENDING = 'ALLOCATION_REQUEST_LIST_PENDING';
export const ALLOCATION_REQUEST_LIST_SUCCESS = 'ALLOCATION_REQUEST_LIST_SUCCESS';
export const ALLOCATION_REQUEST_LIST_FAILURE = 'ALLOCATION_REQUEST_LIST_FAILURE';
export const ALLOCATION_REQUEST_LIST_NO_CONTENT = 'ALLOCATION_REQUEST_LIST_NO_CONTENT';

export const ALLOCATION_REQUEST_PREDICATE_SET = 'ALLOCATION_REQUEST_PREDICATE_SET';
export const ALLOCATION_REQUEST_PAGE_INCREMENT = 'ALLOCATION_REQUEST_PAGE_INCREMENT';
export const ALLOCATION_REQUEST_PAGE_DECREMENT = 'ALLOCATION_REQUEST_PAGE_DECREMENT';
export const ALLOCATION_REQUEST_PAGE_RESET = 'ALLOCATION_REQUEST_PAGE_RESET';

export const ALLOCATION_REQUEST_EDIT_TOGGLE = 'ALLOCATION_REQUEST_EDIT_TOGGLE';
export const ALLOCATION_REQUEST_ITEM_SELECT = 'ALLOCATION_REQUEST_ITEM_SELECT';
export const ALLOCATION_REQUEST_ITEM_DESELECT = 'ALLOCATION_REQUEST_ITEM_DESELECT';
export const ALLOCATION_REQUEST_ITEM_SET = 'ALLOCATION_REQUEST_ITEM_SET';

export const ALLOCATION_COUNTDOWN_RESET = 'ALLOCATION_COUNTDOWN_RESET';
export const ALLOCATION_COUNTDOWN_DECREMENT = 'ALLOCATION_COUNTDOWN_DECREMENT';

export const ALLOCATION_CALENDAR_DATES_SET = 'ALLOCATION_CALENDAR_DATES_SET';

export const ALLOCATION_ARRIVAL_LIST_PENDING = 'ALLOCATION_ARRIVAL_LIST_PENDING';
export const ALLOCATION_ARRIVAL_LIST_SUCCESS = 'ALLOCATION_ARRIVAL_LIST_SUCCESS';
export const ALLOCATION_ARRIVAL_LIST_FAILURE = 'ALLOCATION_ARRIVAL_LIST_FAILURE';
export const ALLOCATION_ARRIVAL_LIST_NO_CONTENT = 'ALLOCATION_ARRIVAL_LIST_NO_CONTENT';

export const ALLOCATION_COMMENT_SET = 'ALLOCATION_COMMENT_SET';
export const ALLOCATION_COMMENT_RESET = 'ALLOCATION_COMMENT_RESET';

// Admin constants
export const ADMIN_USERS_GET_PENDING = 'ADMIN_USERS_GET_PENDING';
export const ADMIN_USERS_GET_SUCCESS = 'ADMIN_USERS_GET_SUCCESS';
export const ADMIN_USERS_GET_NOCONTENT = 'ADMIN_USERS_GET_NOCONTENT';
export const ADMIN_USERS_GET_FAILURE = 'ADMIN_USERS_GET_FAILURE';

export const ADMIN_USER_GET_PENDING = 'ADMIN_USER_GET_PENDING';
export const ADMIN_USER_GET_SUCCESS = 'ADMIN_USER_GET_SUCCESS';
export const ADMIN_USER_GET_NOCONTENT = 'ADMIN_USER_GET_NOCONTENT';
export const ADMIN_USER_GET_FAILURE = 'ADMIN_USER_GET_FAILURE';

export const ADMIN_USER_SET = 'ADMIN_USER_SET';
export const ADMIN_USER_UNSET = 'ADMIN_USER_UNSET';
export const ADMIN_USER_EDIT_VALUES = 'ADMIN_USER_EDIT_VALUES';
export const ADMIN_USER_CREATE_VALUES = 'ADMIN_USER_CREATE_VALUES';

export const ADMIN_USER_CREATE_PENDING = 'ADMIN_USER_CREATE_PENDING';
export const ADMIN_USER_CREATE_SUCCESS = 'ADMIN_USER_CREATE_SUCCESS';
export const ADMIN_USER_CREATE_FAILURE = 'ADMIN_USER_CREATE_FAILURE';

export const ADMIN_USER_EDIT_PENDING = 'ADMIN_USER_EDIT_PENDING';
export const ADMIN_USER_EDIT_SUCCESS = 'ADMIN_USER_EDIT_SUCCESS';
export const ADMIN_USER_EDIT_FAILURE = 'ADMIN_USER_EDIT_FAILURE';

export const ADMIN_USER_EDIT_MODAL_TOGGLE = 'ADMIN_USER_EDIT_MODAL_TOGGLE';
export const ADMIN_USER_CREATE_MODAL_TOGGLE = 'ADMIN_USER_CREATE_MODAL_TOGGLE';

export const ADMIN_ROLES_GET_PENDING = 'ADMIN_ROLES_GET_PENDING';
export const ADMIN_ROLES_GET_SUCCESS = 'ADMIN_ROLES_GET_SUCCESS';
export const ADMIN_ROLES_GET_FAILURE = 'ADMIN_ROLES_GET_FAILURE';
export const ADMIN_ROLES_GET_NO_CONTENT = 'ADMIN_ROLES_GET_NO_CONTENT';

export const ADMIN_LANGUAGES_GET_PENDING = 'ADMIN_LANGUAGES_GET_PENDING';
export const ADMIN_LANGUAGES_GET_SUCCESS = 'ADMIN_LANGUAGES_GET_SUCCESS';
export const ADMIN_LANGUAGES_GET_FAILURE = 'ADMIN_LANGUAGES_GET_FAILURE';
export const ADMIN_LANGUAGES_GET_NO_CONTENT = 'ADMIN_LANGUAGES_GET_NO_CONTENT';

export const ADMIN_FORM_EDIT_SUBMIT = 'ADMIN_FORM_EDIT_SUBMIT';
export const ADMIN_FORM_EDIT_CANCEL = 'ADMIN_FORM_EDIT_CANCEL';
export const ADMIN_FORM_EDIT_ACCEPT = 'ADMIN_FORM_EDIT_ACCEPT';

export const ADMIN_FORM_CREATE_SUBMIT = 'ADMIN_FORM_CREATE_SUBMIT';
export const ADMIN_FORM_CREATE_CANCEL = 'ADMIN_FORM_CREATE_CANCEL';
export const ADMIN_FORM_CREATE_ACCEPT = 'ADMIN_FORM_CREATE_ACCEPT';
export const LANGUAGE_SELECT = 'LANGUAGE_SELECT';
export const LANGUAGE_SET = 'LANGUAGE_SET';

export const ADMIN_COUNTDOWN_DECREMENT = 'ADMIN_COUNTDOWN_DECREMENT';
export const ADMIN_COUNTDOWN_CREATE_RESET = 'ADMIN_COUNTDOWN_CREATE_RESET';
export const ADMIN_COUNTDOWN_EDIT_RESET = 'ADMIN_COUNTDOWN_EDIT_RESET';

export const CSV = 'CSV';

// Info widget constants
export const INFO_WIDGET_TOGGLE = 'INFO_WIDGET_TOGGLE';
export const INFO_WIDGET_PAGE_SELECT = 'INFO_WIDGET_PAGE_SELECT';
export const INFO_WIDGET_PAGE_RESET = 'INFO_WIDGET_PAGE_RESET';
export const INFO_WIDGET_PAGE_INCREMENT = 'INFO_WIDGET_PAGE_INCREMENT';

// Alert constants
export const ALERT_COUNTDOWN_RESET = 'ALERT_COUNTDOWN_RESET';
export const ALERT_COUNTDOWN_DECREMENT = 'ALERT_COUNTDOWN_DECREMENT';


// Dashboard constants
export const DASHBOARD_RESET_STATE = 'DASHBOARD_RESET_STATE';

export const DASHBOARD_AVAILABILITY_PENDING = 'DASHBOARD_AVAILABILITY_PENDING';
export const DASHBOARD_AVAILABILITY_SUCCESS = 'DASHBOARD_AVAILABILITY_SUCCESS';
export const DASHBOARD_AVAILABILITY_FAILURE = 'DASHBOARD_AVAILABILITY_FAILURE';
export const DASHBOARD_AVAILABILITY_NO_CONTENT = 'DASHBOARD_AVAILABILITY_NO_CONTENT';

export const DASHBOARD_AVAILABILITY_ACCOMMODATION_SET = 'DASHBOARD_AVAILABILITY_ACCOMMODATION_SET';

export const DASHBOARD_NOTIFICATIONS_PENDING = 'DASHBOARD_NOTIFICATIONS_PENDING';
export const DASHBOARD_NOTIFICATIONS_SUCCESS = 'DASHBOARD_NOTIFICATIONS_SUCCESS';
export const DASHBOARD_NOTIFICATIONS_FAILURE = 'DASHBOARD_NOTIFICATIONS_FAILURE';
export const DASHBOARD_NOTIFICATIONS_NO_CONTENT = 'DASHBOARD_NOTIFICATIONS_NO_CONTENT';

export const DASHBOARD_NOTIFICATIONS_FILTERS_SET = 'DASHBOARD_NOTIFICATIONS_FILTERS_SET';
export const DASHBOARD_NOTIFICATIONS_PAGE_RESET = 'DASHBOARD_NOTIFICATIONS_PAGE_RESET';
export const DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT = 'DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT';
export const DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT = 'DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT';
export const DASHBOARD_NOTIFICATIONS_LIMIT_SET = 'DASHBOARD_NOTIFICATIONS_LIMIT_SET';

export const DASHBOARD_NOTIFICATIONS_DISMISS_PENDING = 'DASHBOARD_NOTIFICATIONS_DISMISS_PENDING';
export const DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS = 'DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS';
export const DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE = 'DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE';
export const DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT = 'DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT';

export const DASHBOARD_SUPPLIERS_PENDING = 'DASHBOARD_SUPPLIERS_PENDING';
export const DASHBOARD_SUPPLIERS_SUCCESS = 'DASHBOARD_SUPPLIERS_SUCCESS';
export const DASHBOARD_SUPPLIERS_FAILURE = 'DASHBOARD_SUPPLIERS_FAILURE';
export const DASHBOARD_SUPPLIERS_NO_CONTENT = 'DASHBOARD_SUPPLIERS_NO_CONTENT';

export const DASHBOARD_SUPPLIER_SET = 'DASHBOARD_SUPPLIER_SET';

// Account constants
export const ACCOUNT_ACTIVITY_PENDING = 'ACCOUNT_ACTIVITY_PENDING';
export const ACCOUNT_ACTIVITY_SUCCESS = 'ACCOUNT_ACTIVITY_SUCCESS';
export const ACCOUNT_ACTIVITY_FAILURE = 'ACCOUNT_ACTIVITY_FAILURE';
export const ACCOUNT_ACTIVITY_NO_CONTENT = 'ACCOUNT_ACTIVITY_NO_CONTENT';

export const ACCOUNT_NOTIFICATIONS_PENDING = 'ACCOUNT_NOTIFICATIONS_PENDING';
export const ACCOUNT_NOTIFICATIONS_SUCCESS = 'ACCOUNT_NOTIFICATIONS_SUCCESS';
export const ACCOUNT_NOTIFICATIONS_FAILURE = 'ACCOUNT_NOTIFICATIONS_FAILURE';
export const ACCOUNT_NOTIFICATIONS_NO_CONTENT = 'ACCOUNT_NOTIFICATIONS_NO_CONTENT';

export const ACCOUNT_ACTIVITY_ROWS_SET = 'ACCOUNT_ACTIVITY_ROWS_SET';

export const ACCOUNT_ACTIVITY_PAGE_INCREMENT = 'ACCOUNT_ACTIVITY_PAGE_INCREMENT';
export const ACCOUNT_ACTIVITY_PAGE_DECREMENT = 'ACCOUNT_ACTIVITY_PAGE_DECREMENT';
export const ACCOUNT_ACTIVITY_PAGE_RESET = 'ACCOUNT_ACTIVITY_PAGE_RESET';

export const ACCOUNT_NOTIFICATION_TOGGLE_PENDING = 'ACCOUNT_NOTIFICATION_TOGGLE_PENDING';
export const ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS = 'ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS';
export const ACCOUNT_NOTIFICATION_TOGGLE_FAILURE = 'ACCOUNT_NOTIFICATION_TOGGLE_FAILURE';

export const ACCOUNT_NOTIFICATION_UPDATE_PENDING = 'ACCOUNT_NOTIFICATION_UPDATE_PENDING';
export const ACCOUNT_NOTIFICATION_UPDATE_SUCCESS = 'ACCOUNT_NOTIFICATION_UPDATE_SUCCESS';
export const ACCOUNT_NOTIFICATION_UPDATE_FAILURE = 'ACCOUNT_NOTIFICATION_UPDATE_FAILURE';
export const ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT = 'ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT';

export const ACCOUNT_NOTIFICATION_EDIT = 'ACCOUNT_NOTIFICATION_EDIT';
export const ACCOUNT_NOTIFICATION_EDIT_TOGGLE = 'ACCOUNT_NOTIFICATION_EDIT_TOGGLE';

export const ACCOUNT_USER_EDIT = 'ACCOUNT_USER_EDIT';
export const ACCOUNT_USER_RESET = 'ACCOUNT_USER_RESET';

export const ACCOUNT_PASSWORD_EDIT = 'ACCOUNT_PASSWORD_EDIT';
export const ACCOUNT_PASSWORD_RESET = 'ACCOUNT_PASSWORD_RESET';

export const ACCOUNT_USER_PENDING = 'ACCOUNT_USER_PENDING';
export const ACCOUNT_USER_SUCCESS = 'ACCOUNT_USER_SUCCESS';
export const ACCOUNT_USER_FAILURE = 'ACCOUNT_USER_FAILURE';
export const ACCOUNT_USER_NO_CONTENT = 'ACCOUNT_USER_NO_CONTENT';

export const ACCOUNT_USER_UPDATE_PENDING = 'ACCOUNT_USER_UPDATE_PENDING';
export const ACCOUNT_USER_UPDATE_SUCCESS = 'ACCOUNT_USER_UPDATE_SUCCESS';
export const ACCOUNT_USER_UPDATE_FAILURE = 'ACCOUNT_USER_UPDATE_FAILURE';
export const ACCOUNT_USER_UPDATE_NO_CONTENT = 'ACCOUNT_USER_UPDATE_NO_CONTENT';

export const ACCOUNT_PASSWORD_UPDATE_PENDING = 'ACCOUNT_PASSWORD_UPDATE_PENDING';
export const ACCOUNT_PASSWORD_UPDATE_SUCCESS = 'ACCOUNT_PASSWORD_UPDATE_SUCCESS';
export const ACCOUNT_PASSWORD_UPDATE_FAILURE = 'ACCOUNT_PASSWORD_UPDATE_FAILURE';
export const ACCOUNT_PASSWORD_UPDATE_NO_CONTENT = 'ACCOUNT_PASSWORD_UPDATE_NO_CONTENT';

// Introduction constants
export const INTRODUCTION_CONFIRM_SEND_PENDING = 'INTRODUCTION_CONFIRM_SEND_PENDING';
export const INTRODUCTION_CONFIRM_SEND_SUCCESS = 'INTRODUCTION_CONFIRM_SEND_SUCCESS';
export const INTRODUCTION_CONFIRM_SEND_FAILURE = 'INTRODUCTION_CONFIRM_SEND_FAILURE';
export const INTRODUCTION_CONFIRM_SEND_WARNING = 'INTRODUCTION_CONFIRM_SEND_WARNING';
export const INTRODUCTION_CONFIRM_SEND_NO_CONTENT = 'INTRODUCTION_CONFIRM_SEND_NO_CONTENT';

// Contract management constants
export const CONTRACT_MANAGEMENT_RESET_STATE = 'CONTRACT_MANAGEMENT_RESET_STATE';

export const CONTRACT_MANAGEMENT_OVERVIEW_PENDING = 'CONTRACT_MANAGEMENT_OVERVIEW_PENDING';
export const CONTRACT_MANAGEMENT_YEARS_SUCCESS = 'CONTRACT_MANAGEMENT_YEARS_SUCCESS';
export const CONTRACT_MANAGEMENT_YEARS_NO_CONTENT = 'CONTRACT_MANAGEMENT_YEARS_NO_CONTENT';
export const CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS = 'CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS';
export const CONTRACT_MANAGEMENT_OVERVIEW_FAILURE = 'CONTRACT_MANAGEMENT_OVERVIEW_FAILURE';
export const CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT = 'CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT';

export const CONTRACT_MANAGEMENT_FILTER_SET = 'CONTRACT_MANAGEMENT_FILTER_SET';
export const CONTRACT_MANAGEMENT_LIST_LIMIT_SET = 'CONTRACT_MANAGEMENT_LIST_LIMIT_SET';
export const CONTRACT_MANAGEMENT_LIST_YEAR_SET = 'CONTRACT_MANAGEMENT_LIST_YEAR_SET';
export const CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT = 'CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT';
export const CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT = 'CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT';
export const CONTRACT_MANAGEMENT_LIST_PAGE_RESET = 'CONTRACT_MANAGEMENT_LIST_PAGE_RESET';
export const CONTRACT_MANAGEMENT_LIST_SHOW_SET = 'CONTRACT_MANAGEMENT_LIST_SHOW_SET';
export const CONTRACT_MANAGEMENT_LIST_SEARCH_SET = 'CONTRACT_MANAGEMENT_LIST_SEARCH_SET';

export const CONTRACT_MANAGEMENT_DATA_PENDING = 'CONTRACT_MANAGEMENT_DATA_PENDING';
export const CONTRACT_MANAGEMENT_DATA_SUCCESS = 'CONTRACT_MANAGEMENT_DATA_SUCCESS';
export const CONTRACT_MANAGEMENT_DATA_FAILURE = 'CONTRACT_MANAGEMENT_DATA_FAILURE';
export const CONTRACT_MANAGEMENT_DATA_NO_CONTENT = 'CONTRACT_MANAGEMENT_DATA_NO_CONTENT';

export const CONTRACT_MANAGEMENT_FORM_SET = 'CONTRACT_MANAGEMENT_FORM_SET';
export const CONTRACT_MANAGEMENT_FORM_UNSET = 'CONTRACT_MANAGEMENT_FORM_UNSET';
export const CONTRACT_MANAGEMENT_PART_SET = 'CONTRACT_MANAGEMENT_PART_SET';
export const CONTRACT_MANAGEMENT_FORM_FILE_REMOVE = 'CONTRACT_MANAGEMENT_FORM_FILE_REMOVE';

export const CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING';
export const CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS';
export const CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE';
export const CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT';

export const CONTRACT_MANAGEMENT_FORM_PAGE_SET = 'CONTRACT_MANAGEMENT_FORM_PAGE_SET';

export const CONTRACT_MANAGEMENT_FORM_SAVE_PENDING = 'CONTRACT_MANAGEMENT_FORM_SAVE_PENDING';
export const CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS';
export const CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE = 'CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE';
export const CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT';

export const CONTRACT_MANAGEMENT_PROGRESS_SET = 'CONTRACT_MANAGEMENT_PROGRESS_SET';

export const CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING';
export const CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS';
export const CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE';
export const CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT';

export const CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING = 'CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING';
export const CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS';
export const CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE = 'CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE';
export const CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT';

export const CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD = 'CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD';
export const CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE = 'CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE';

export const CONTRACT_MANAGEMENT_FORM_INDEX_SET = 'CONTRACT_MANAGEMENT_FORM_INDEX_SET';
export const CONTRACT_MANAGEMENT_FORM_INDEX_RESET = 'CONTRACT_MANAGEMENT_FORM_INDEX_RESET';

export const CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING';
export const CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS';
export const CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE';
export const CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT';

export const CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING = 'CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING';
export const CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS = 'CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS';
export const CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE = 'CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE';

export const CONTRACT_MANAGEMENT_NO_CHANGES_SET = 'CONTRACT_MANAGEMENT_NO_CHANGES_SET';

export const CONTRACT_MANAGEMENT_GET_BRANDS_PENDING = 'CONTRACT_MANAGEMENT_GET_BRANDS_PENDING';
export const CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS = 'CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS';
export const CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT = 'CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT';
export const CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE = 'CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE';

export const CONTRACT_MANAGEMENT_ADD_BRAND = 'CONTRACT_MANAGEMENT_ADD_BRAND';
export const CONTRACT_MANAGEMENT_REMOVE_BRAND = 'CONTRACT_MANAGEMENT_REMOVE_BRAND';

export const CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING = 'CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING';
export const CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS = 'CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS';
export const CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS = 'CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS';
export const CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT= 'CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT';
export const CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE = 'CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE';

// Contract constants
export const CONTRACT_DATA_PENDING = 'CONTRACT_DATA_PENDING';
export const CONTRACT_DATA_SUCCESS = 'CONTRACT_DATA_SUCCESS';
export const CONTRACT_DATA_FAILURE = 'CONTRACT_DATA_FAILURE';
export const CONTRACT_DATA_NO_CONTENT = 'CONTRACT_DATA_NO_CONTENT';
export const CONTRACT_DATA_PRODUCT_ERROR = 'CONTRACT_DATA_PRODUCT_ERROR';

export const CONTRACT_NOTES_PENDING = 'CONTRACT_NOTES_PENDING';
export const CONTRACT_NOTES_SUCCESS = 'CONTRACT_NOTES_SUCCESS';
export const CONTRACT_NOTES_FAILURE = 'CONTRACT_NOTES_FAILURE';
export const CONTRACT_NOTES_NO_CONTENT = 'CONTRACT_NOTES_NO_CONTENT';

export const CONTRACT_HISTORY_PENDING = 'CONTRACT_HISTORY_PENDING';
export const CONTRACT_HISTORY_SUCCESS = 'CONTRACT_HISTORY_SUCCESS';
export const CONTRACT_HISTORY_FAILURE = 'CONTRACT_HISTORY_FAILURE';
export const CONTRACT_HISTORY_NO_CONTENT = 'CONTRACT_HISTORY_NO_CONTENT';

export const CONTRACT_FORM_PART_SET = 'CONTRACT_FORM_PART_SET';

export const CONTRACT_FORM_PART_ACCEPT_PENDING = 'CONTRACT_FORM_PART_ACCEPT_PENDING';
export const CONTRACT_FORM_PART_ACCEPT_SUCCESS = 'CONTRACT_FORM_PART_ACCEPT_SUCCESS';
export const CONTRACT_FORM_PART_ACCEPT_FAILURE = 'CONTRACT_FORM_PART_ACCEPT_FAILURE';

export const CONTRACT_FORM_NOTES_SET = 'CONTRACT_FORM_NOTES_SET';

export const CONTRACT_FORM_SAVE_PENDING = 'CONTRACT_FORM_SAVE_PENDING';
export const CONTRACT_FORM_SAVE_SUCCESS = 'CONTRACT_FORM_SAVE_SUCCESS';
export const CONTRACT_FORM_SAVE_FAILURE = 'CONTRACT_FORM_SAVE_FAILURE';

export const CONTRACT_FINISH_PENDING = 'CONTRACT_FINISH_PENDING';
export const CONTRACT_FINISH_SUCCESS = 'CONTRACT_FINISH_SUCCESS';
export const CONTRACT_FINISH_FAILURE = 'CONTRACT_FINISH_FAILURE';
export const CONTRACT_FINISH_NO_CONTENT = 'CONTRACT_FINISH_NO_CONTENT';

export const CONTRACT_DOWNLOAD_PENDING ='CONTRACT_DOWNLOAD_PENDING';
export const CONTRACT_DOWNLOAD_SUCCESS ='CONTRACT_DOWNLOAD_SUCCESS';
export const CONTRACT_DOWNLOAD_FAILURE ='CONTRACT_DOWNLOAD_FAILURE';

export const CONTRACT_NOTE_SET = 'CONTRACT_NOTE_SET';

export const CONTRACT_NOTE_CREATE_PENDING = 'CONTRACT_NOTE_CREATE_PENDING';
export const CONTRACT_NOTE_CREATE_SUCCESS = 'CONTRACT_NOTE_CREATE_SUCCESS';
export const CONTRACT_NOTE_CREATE_FAILURE = 'CONTRACT_NOTE_CREATE_FAILURE';

export const CONTRACT_ACCEPT_LIST_PENDING = 'CONTRACT_ACCEPT_LIST_PENDING';
export const CONTRACT_ACCEPT_LIST_SUCCESS = 'CONTRACT_ACCEPT_LIST_SUCCESS';
export const CONTRACT_ACCEPT_LIST_FAILURE = 'CONTRACT_ACCEPT_LIST_FAILURE';

export const CONTRACT_NOTE_EMAIL_PENDING = 'CONTRACT_NOTE_EMAIL_PENDING';
export const CONTRACT_NOTE_EMAIL_SUCCESS = 'CONTRACT_NOTE_EMAIL_SUCCESS';
export const CONTRACT_NOTE_EMAIL_FAILURE = 'CONTRACT_NOTE_EMAIL_FAILURE';

export const CONTRACT_RESET_STATE = 'CONTRACT_RESET_STATE';

export const CONTRACT_DRAFT_PENDING = 'CONTRACT_DRAFT_PENDING';
export const CONTRACT_DRAFT_SUCCESS = 'CONTRACT_DRAFT_SUCCESS';
export const CONTRACT_DRAFT_FAILURE = 'CONTRACT_DRAFT_FAILURE';

// Instruction constants
export const INSTRUCTION_DISMISS = 'INSTRUCTION_DISMISS';



// WEBPACK FOOTER //
// ./src/store/constants.js